import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject, Subject, of } from 'rxjs';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { UserService } from 'src/app/user/service/user.abstract.service';
import { UserReceiptDetailDialogComponent } from '../../../dialogs/user-receipt-detail-dialog/user-receipt-detail-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../../../global/services/message/message.abstract.service';
import { languageSelector } from '../../../../global/store/global.selectors';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';

@Component({
    selector: 'app-user-receipts',
    templateUrl: './user-receipts.component.html',
    styleUrls: ['./user-receipts.component.scss'],
})
export class UserReceiptsComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    update$ = new ReplaySubject();

    myReceiptsPageOptions: any = {
        page: 1,
        pageSize: 10,
    };

    loading = false;

    receipts = [];

    constructor(
        private userService: UserService,
        private messageService: MessageService,
        private dialog: MatDialog,
        private translateService: TranslateService,
        private route: ActivatedRoute,
        private store: Store<State>,
    ) {}

    ngOnInit(): void {
        this.store
            .select(languageSelector)
            .pipe(takeUntil(this.destroy$))
            .subscribe((lang) => this.translateService.use(lang));

        this.translateService.onLangChange
            .pipe(
                takeUntil(this.destroy$),
                tap(() => this.update$.next()),
            )
            .subscribe();

        this.update$
            .pipe(
                takeUntil(this.destroy$),
                tap(() => (this.loading = true)),
                switchMap(() => this.route.paramMap.pipe(switchMap((params) => of(params.get('id'))))),
                switchMap((id) =>
                    this.userService.getUserReceipts(id, this.myReceiptsPageOptions.page, this.myReceiptsPageOptions.pageSize).pipe(
                        takeUntil(this.destroy$),
                        map((response) => {
                            this.myReceiptsPageOptions = {
                                ...this.myReceiptsPageOptions,
                                page: response.page - 1,
                                length: response.totalDocs,
                                pageSize: response.limit,
                                hasNextPage: response.hasNextPage,
                                hasPrevPage: response.hasPrevPage,
                            };
                            this.receipts = response.docs;
                            this.loading = false;
                        }),
                        catchError((error) => {
                            this.messageService.error('error getting receipts');
                            return of();
                        }),
                    ),
                ),
            )
            .subscribe();

        this.update$.next();
    }

    myReceiptsPageChange(e) {
        ((this.myReceiptsPageOptions = {
            ...this.myReceiptsPageOptions,
            page: e.pageIndex + 1,
            pageSize: e.pageSize,
            length: e.length,
        }),
            this.update$.next());
    }

    openReceiptDetailsDialog(item: any) {
        this.dialog.open(UserReceiptDetailDialogComponent, {
            data: item,
            panelClass: 'receipt-dialog-component',
            maxWidth: '520px',
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
